module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.item) ? _c('div', {
    staticClass: "component component-invoice invoice"
  }, [(_vm.$is('listing')) ? _c('div', {
    staticClass: "invoice-list"
  }, [_c('div', {
    staticClass: "component-card"
  }, [_c('div', {
    staticClass: "row collapse"
  }, [_c('div', {
    staticClass: "columns shrink align-self-middle"
  }, [_c('dropdown', {
    attrs: {
      "icon": 'fa fa-ellipsis-v fa-2x action',
      "position": 'bottom'
    }
  }, [_c('invoice-action-buttons', {
    attrs: {
      "invoice": _vm.item
    }
  })], 1)], 1), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns align-self-middle"
  }, [_c('invoice-fields', {
    attrs: {
      "item": _vm.item,
      "type": 'invoice-number'
    }
  }), _c('div', {
    staticClass: "type"
  }, [_vm._v(_vm._s(_vm.item.type))])], 1), _c('div', {
    staticClass: "columns align-self-middle"
  }, [_c('invoice-fields', {
    attrs: {
      "item": _vm.item,
      "type": 'invoice-emission-date'
    }
  })], 1), _c('div', {
    staticClass: "columns align-self-middle"
  }, [_c('invoice-fields', {
    attrs: {
      "item": _vm.item,
      "type": 'invoice-due-date'
    }
  })], 1), _c('div', {
    staticClass: "columns align-self-middle"
  }, [_c('invoice-fields', {
    attrs: {
      "item": _vm.item,
      "type": 'invoice-client-info'
    }
  })], 1), _c('div', {
    staticClass: "columns align-self-middle"
  }, [_c('invoice-fields', {
    attrs: {
      "item": _vm.item,
      "type": 'invoice-tax'
    }
  })], 1), _c('div', {
    staticClass: "columns align-self-middle"
  }, [_c('invoice-fields', {
    attrs: {
      "item": _vm.item,
      "type": 'invoice-total'
    }
  })], 1), _c('div', {
    staticClass: "columns align-self-middle"
  }, [_c('div', {
    staticClass: "field-value"
  }, [_vm._v("NET TO PAY:")]), _c('span', [_vm._v(_vm._s(_vm.$priceWithcurrency(_vm.item.total)))])]), _c('div', {
    staticClass: "columns align-self-middle"
  }, [_c('invoice-fields', {
    attrs: {
      "item": _vm.item,
      "type": 'invoice-status'
    }
  })], 1)])]), _c('div', {
    staticClass: "columns shrink align-self-middle"
  }, [_c('div', {
    staticClass: "row align-center align-middle",
    attrs: {
      "slot": "actionPage"
    },
    slot: "actionPage"
  }, [_c('is-module-enabled', {
    attrs: {
      "module": "italian-e-invoice"
    }
  }, [_c('ActionButton', {
    attrs: {
      "action": _vm.downloadXML,
      "button": false
    }
  }, [_c('div', {
    staticClass: "fa fa-code fa-2x",
    style: (_vm.xmlStatus)
  })])], 1), _c('a', {
    staticClass: "fa fa-file-pdf-o fa-2x",
    on: {
      "click": function($event) {
        return _vm.openUrl(_vm.item.url)
      }
    }
  }), _c('router-link', {
    attrs: {
      "to": {
        name: 'invoice',
        params: {
          id: _vm.item.id
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right fa-2x action"
  })])], 1)])])])]) : _vm._e(), (_vm.$is('client-invoices')) ? _c('div', {
    staticClass: "invoice-list"
  }, [_c('div', {
    staticClass: "client-invoices"
  }, [_c('div', {
    staticClass: "component-card"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column expand"
  }, [_c('h3', {
    staticClass: "mb-0"
  }, [_vm._v(_vm._s(_vm.label) + _vm._s(_vm.item.internal_id) + "(" + _vm._s(_vm.item.number) + ")")]), (_vm.label === 'INV') ? _c('small', [_c('strong', [_vm._v(_vm._s(_vm.item.status))]), (_vm.item.status == 'PAID') ? _c('span', [_vm._v(": " + _vm._s(_vm.$dateFormat(_vm.item.payed_on, _vm.$toMomentFormat(_vm.configuration.locale.locale_date_format.value))))]) : _vm._e()]) : _vm._e()]), _c('div', {
    staticClass: "column shrink"
  }, [_c('div', {
    staticClass: "field-content"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Emission")]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(" " + _vm._s(_vm.$dateFormat(_vm.item.emission_date, _vm.$toMomentFormat(_vm.configuration.locale.locale_date_format.value))))])]), (_vm.label !== 'CRN') ? _c('div', {
    staticClass: "field-content"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Due date")]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.due_date, _vm.$toMomentFormat(_vm.configuration.locale.locale_date_format.value))))])]) : _vm._e()]), _c('div', {
    staticClass: "column shrink",
    staticStyle: {
      "padding-left": "0",
      "padding-right": "0"
    }
  }, [(_vm.label === 'INV' || _vm.label === 'PRO') ? _c('dropdown', {
    attrs: {
      "icon": 'fa fa-ellipsis-v fa-2x action',
      "position": 'bottom'
    }
  }, [_c('invoice-action-buttons', {
    attrs: {
      "invoice": _vm.item
    }
  })], 1) : _vm._e()], 1)]), _c('div', {
    staticClass: "row text-center pt-0 bottom"
  }, [_c('div', {
    staticClass: "column shrink p-1"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Tax")]), _c('h3', [_vm._v(" " + _vm._s(_vm.$priceWithcurrency(_vm.item.tax)))])]), _c('div', {
    staticClass: "column shrink p-1"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Subtotal")]), _c('h3', [_vm._v(" " + _vm._s(_vm.$priceWithcurrency(_vm.item.subtotal)))])]), _c('div', {
    staticClass: "column shrink p-1"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Total")]), _c('h3', [_vm._v(" " + _vm._s(_vm.$priceWithcurrency(_vm.item.document_total)))])]), _c('div', {
    staticClass: "column shrink p-1"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Net to Pay")]), _c('h3', [_vm._v(" " + _vm._s(_vm.$priceWithcurrency(_vm.item.total)))])]), _c('div', {
    staticClass: "column shrink"
  }, [_c('label', [_vm._v(" ")]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column shrink pl-0 pr-0"
  }, [_c('is-module-enabled', {
    attrs: {
      "module": "italian-e-invoice"
    }
  }, [_c('ActionButton', {
    attrs: {
      "action": _vm.downloadXML,
      "button": false
    }
  }, [_c('div', {
    staticClass: "fa fa-code fa-2x",
    style: (_vm.xmlStatus)
  })])], 1)], 1), _c('div', {
    staticClass: "column shrink pl-0 pr-0"
  }, [_c('a', {
    staticClass: "fa fa-2x fa-file-pdf-o",
    on: {
      "click": function($event) {
        return _vm.openUrl(_vm.item.url)
      }
    }
  })]), _c('div', {
    staticClass: "column shrink pl-0 pr-0"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'invoice',
        params: {
          id: _vm.item.id
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-2x fa-angle-right action"
  })])], 1)])])])])])]) : _vm._e(), (_vm.$is('einvoice')) ? _c('div', {
    staticClass: "client-invoices"
  }, [_c('CardN', {
    attrs: {
      "columns": 3
    }
  }, [_c('div', {
    attrs: {
      "slot": "n1"
    },
    slot: "n1"
  }, [_vm._v("File name:")]), _c('div', {
    attrs: {
      "slot": "n1"
    },
    slot: "n1"
  }, [_vm._v(_vm._s(_vm.item.uploadFileName))]), _c('div', {
    attrs: {
      "slot": "n2"
    },
    slot: "n2"
  }, [_vm._v(_vm._s(_vm.item.errorCode) + " - " + _vm._s(_vm.item.errorDescription))]), _c('div', {
    attrs: {
      "slot": "n3"
    },
    slot: "n3"
  }, [_vm._v("Date")]), _c('div', {
    attrs: {
      "slot": "n3"
    },
    slot: "n3"
  }, [_vm._v(_vm._s(_vm.item.created_at))])])], 1) : _vm._e(), (_vm.$is('record-details')) ? _c('div', {
    staticClass: "invoice-list"
  }) : _vm._e()]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9a6f07f4!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/Invoice.vue
// module id = 2483
// module chunks = 1